import _get from 'lodash/get';

const CHEVRON_MARGIN = 30;

const getChildrensTotalWidth = (el: HTMLElement): number => {
  const totalWidth = Object.values(el.childNodes).reduce(
    (total, i: HTMLElement) => total + i.offsetWidth,
    0,
  );
  return totalWidth;
};

const recalculateChevronVisibility = (
  scrollableWrapper,
  setShowLeftChevron: (boolean) => void,
  setShowRightChevron: (boolean) => void,
): void => {
  const wrapper = _get(scrollableWrapper, 'current.children[1]');
  if (!wrapper) return;

  const wrapperScroll = wrapper.scrollLeft;
  setShowLeftChevron(wrapperScroll > 0);

  const [deepWrapper] = wrapper.children;
  const totalChildrensWidth =
    getChildrensTotalWidth(deepWrapper as HTMLElement) + CHEVRON_MARGIN;

  const maxScrolled =
    Math.abs(wrapper.scrollWidth - wrapper.scrollLeft - wrapper.clientWidth) <=
    3.0; //  3.0 is the tolerance

  const wrapperSize = scrollableWrapper.current.offsetWidth;
  setShowRightChevron(!maxScrolled && totalChildrensWidth > wrapperSize);
};

const getButtonsInsideMenu = (
  wrapper,
  wrapperSize,
  previousButtonClicked = false,
) => {
  const wrapperScroll = wrapper.scrollLeft;
  const [deepWrapper] = wrapper.children;
  const buttons = Array.from(deepWrapper.children) as HTMLElement[];
  const buttonsInside = [];
  const previousOffset = previousButtonClicked ? wrapperSize : 0;
  let isFirstSet = false;

  for (let i = 0; i < buttons.length; i += 1) {
    const button = buttons[i];
    const buttonOffset = button.offsetLeft;
    const buttonInsideWrapper =
      buttonOffset >= wrapperScroll - previousOffset &&
      buttonOffset <= wrapperScroll + wrapperSize - previousOffset;

    if (buttonInsideWrapper) {
      if (i === 0) {
        isFirstSet = true;
      }
      buttonsInside.push(button);
    }
  }

  return { buttonsInside, isFirstSet };
};

export const tabsNavUtils = {
  getButtonsInsideMenu,
  getChildrensTotalWidth,
  recalculateChevronVisibility,
};
